import type { CreateLabelRequest, CreateLabelResponse } from '@vy/api-definition';
import { CreateLabelResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useCreateLabel(
  options?: UseMutationOptions<CreateLabelResponse, unknown, CreateLabelRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (createLabelRequest) => {
      const api = getPrivateApi();
      const createLabelResponse = await api.createLabel({
        createLabelRequest,
      });

      return CreateLabelResponseSchema.parse(createLabelResponse);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [queryKeys.labels()],
        });
      },
      ...options,
    },
  );
}
